import ShopTwoIcon from "@mui/icons-material/ShopTwo";
import { FormattedMessage, useIntl } from "react-intl";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
// icons

const useADSItem = () => {
  const icons = {
    ShopTwoIcon,
    BusinessOutlinedIcon,
    WhereToVoteIcon,
  };

  // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

  const packages = {
    id: "ads-management",
    title: (
      <FormattedMessage id="Ads Management">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.BusinessOutlinedIcon,
    type: "group",
    // url: "/banners",
    children: [
      {
        id: "banners-mangment",
        title: <FormattedMessage id="Banners Management" />,
        type: "item",
        url: "/banners",
        icon: icons.ShopTwoIcon,
        breadcrumbs: false,
      },

      {
        id: "best-place",
        title: <FormattedMessage id="Best Place" />,
        type: "item",
        url: "/best-place",
        icon: icons.WhereToVoteIcon,
        breadcrumbs: false,
      },

      {
        id: "top-company",
        title: <FormattedMessage id="Top Companies" />,
        type: "item",
        url: "/top-company",
        icon: icons.BusinessOutlinedIcon,
        breadcrumbs: false,
      },
    ],
  };
  return packages;
};

export default useADSItem;
